import type { MaybeRefOrGetter } from 'vue';
import { useLocalStorage } from '@vueuse/core';
import { computed, toValue } from 'vue';

interface UseDevtoolsFlagOptions {
	defaultValue?: boolean;
	prefix?: string;
}

/**
 * Composable for managing dev flags in localStorage
 *
 * @param flagName - The flag name (will be prefixed with 'monospace-dev-')
 * @param options - Configuration options
 * @returns Object with reactive flag state
 */
export function useDevtoolsFlag(
	flagName: MaybeRefOrGetter<string>,
	options: UseDevtoolsFlagOptions = {},
) {
	const { defaultValue = true, prefix = 'monospace-dev-' } = options;

	const key = computed(() => `${prefix}${toValue(flagName)}`);

	const isEnabled = useLocalStorage(key, defaultValue);

	return { isEnabled };
}
